/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { getPaymentDetailsV1 } from '@modules/billing-api/v1/callers'
import type { QueryHook, QueryHookOptions } from '@modules/query/types'
import { queryClient } from '@modules/query'

import { defaultBillingOptions } from './constants'

const GET_PAYMENT_DETAILS_QUERY_KEY = 'getPaymentDetailsV1'

const useGetPaymentDetails: QueryHook<typeof getPaymentDetailsV1> = (
  organizationId: string,
  options?: QueryHookOptions,
) =>
  useQuery(
    [GET_PAYMENT_DETAILS_QUERY_KEY, organizationId],
    () => getPaymentDetailsV1({ pathParameters: { organization_id: organizationId } }),
    {
      ...defaultBillingOptions,
      ...options,
      enabled: Boolean(organizationId),
    },
  )

export const invalidateGetPaymentDetails = () =>
  queryClient.invalidateQueries({ queryKey: [GET_PAYMENT_DETAILS_QUERY_KEY] })

export default useGetPaymentDetails
